export default __webpack_public_path__ + "static/media/mDAI.1096719c.svg";